import _ from 'lodash';
import React from 'react';
import { IProps } from './types';
import commonService from 'utils/commonService';

const MobileDeviceRules: React.FC<IProps> = (props) => {
  return (
    <div className="mobile-device-insure-rules">
      {
        props.mobileLmt && props.mobileLmt[0] && props.mobileLmt[0].length > 0 && (
          <div className="mobile-device-insure-rules__mobdevlmt-table">
            <div className="mobile-device-insure-rules__mobdevlmt-table-title">保障內容</div>
            <div className="mobile-device-insure-rules__remind-section">
              <div className="mobile-device-insure-rules__remind-container">
                <div className="mobile-device-insure-rules__remind-content">
                  {
                    _.map(props.mobileLmt, (strArray:string[]) => {
                      return _.map(strArray, (str:string, index:number) => {
                        return React.cloneElement(
                          <>
                            <span>{commonService.htmlParser(`<div style='display: flex;'><span>◆</span><span style='padding:0 10px'>${str}</span></div>`)}</span>
                          </>
                          , { key: index });
                      });
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        )
      }
      {
        props.mobileMainLmt && props.mobileMainLmt[0] && props.mobileMainLmt[0].length > 0 && (
          <div className="mobile-device-insure-rules__prod-limit-table">
            <div className="mobile-device-insure-rules__prod-limit-table-title">主要給付項目</div>
            <div className="mobile-device-insure-rules__remind-section">
              <div className="mobile-device-insure-rules__remind-container">
                <div className="mobile-device-insure-rules__remind-content">
                  {
                    _.map(props.mobileMainLmt, (strArray:string[]) => {
                      return _.map(strArray, (str:string, index:number) => {
                        return React.cloneElement(
                          <>
                            <span>{commonService.htmlParser(`<div style='display: flex;'><span>◆</span><span style='padding:0 10px'>${str}</span></div>`)}</span>
                          </>
                          , { key: index });
                      });
                    })
                  }
                </div>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default MobileDeviceRules;
